<template>
    <div>
        <el-button class="marB10" @click="addFun" :class="baseerp+'btn'" size="mini">
            新增
        </el-button>
        <el-button class="marB10" @click="deleteFun" :class="baseerp+'btn'" size="mini">
            删除
        </el-button>
        <el-table @selection-change="handleSelectionChange" row-key="i_id" class="mrt10" ref="table" size="mini" :height="tableHeight" border :data="tableData"
                   :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
            <el-table-column  align="center"  :selectable="selectable"  type="selection" width="50px" ></el-table-column>
            <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>

            <el-table-column prop="vc_phone" label="手机号" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-input v-if="scope.row.operate=='1'"  @change="phoneNumberChange(scope.row,scope.$index)" v-model="scope.row.vc_phone" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                    <div class="mrA" v-else>{{scope.row.vc_phone}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="vc_code" label="手机唯一号" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-input v-if="scope.row.operate=='1'" @change="phonecodeChange(scope.row,scope.$index)" v-model="scope.row.vc_code" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                    <div class="mrA" v-else>{{scope.row.vc_code}}</div>
                </template>
            </el-table-column>
        </el-table>
        <div  class="center">
            <el-button type="primary" @click="saveFun" :class="baseerp+'btn'" size="mini">{{$t('button_save')}}</el-button>

            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    export default {
        name: "DetailPage",
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                tableData:[],
                multipleSelection:[],
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.getList()
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })

        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            cancel(){
              this.$emit('close')
            },
            addFun(){
                this.tableData.unshift({
                    vc_phone:null,
                    vc_code:null,
                    operate:'1',
                    vc_name:this.data.val.vc_username,
                    i_uid:this.data.val.i_userid,
                })
            },
            handleSelectionChange(val,row) {
                this.multipleSelection = val;
            },
            selectable(row){
                if(row.operate=='1'){
                    return false
                }else{
                    return true
                }
            },

            docodeValidate(vc_code) {
                if (!vc_code) {
                    this.$message.warning('手机唯一号不能为空');
                    return false;
                }

                return true; // 校验通过
            },

            phonecodeChange(row,index){

                if(!this.docodeValidate(row.vc_code)){
                    this.$set(this.tableData[index],'vc_code',null)
                }
            },
            doValidate(vc_phone) {
                if (!vc_phone) {
                    this.$message.warning('手机号不能为空');
                    return false;
                }
                // 中国大陆手机号正则 (可根据需求调整)
                const phoneReg = /^[0-9-()\s+]+$/;
                if (!phoneReg.test(vc_phone)) {
                    this.$message.warning('请输入正确的11位手机号码');
                    return false;
                }
                return true; // 校验通过
            },
            phoneNumberChange(row,index){

                if(!this.doValidate(row.vc_phone)){
                    this.$set(this.tableData[index],'vc_phone',null)
                }
            },
            saveFun(){
                let addarr = this.tableData.filter(t=> t.operate=='1');
                let arr= this.tableData.filter(t=>this.doValidate(t.vc_phone)==false||!this.docodeValidate(t.vc_code));
                if(arr.length==0&&addarr.length>0) {
                    this.$confirm('是否新增这' + addarr.length + '数据', this.$t('tips_prompt'), {
                        // this.$confirm(this.$t('companyManageMD_do_you_want_to_these_pieces_of_data',[typename,tableData.length]),this.$t('tips_prompt'),{
                        confirmButtonText: this.$t('button_sure'),
                        cancelButtonText: this.$t('button_cancel'),
                        type: "warning"
                    }).then(() => {
                        this.addOrDelete(addarr)
                    }).catch(() => {
                        this.$message.info(this.$t('tips_cancel_operation'))
                    })
                }
                if(addarr.length==0){
                    this.$message.warning('请新增数据');

                }
            },
            async addOrDelete(tableData){

                let param={
                    devices:tableData,
                };
                let res=await API.addOrDelete(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message);
                    this.cancel()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            deleteFun(){
                console.log('----------')
                let arr= this.multipleSelection.filter(t=>t.operate=='0');
                if(arr.length>0) {
                    this.$confirm('是否删除这' + arr.length + '数据', this.$t('tips_prompt'), {
                        // this.$confirm(this.$t('companyManageMD_do_you_want_to_these_pieces_of_data',[typename,tableData.length]),this.$t('tips_prompt'),{
                        confirmButtonText: this.$t('button_sure'),
                        cancelButtonText: this.$t('button_cancel'),
                        type: "warning"
                    }).then(() => {
                        arr.map(a=>a.operate=2);
                        this.addOrDelete(arr)
                    }).catch(() => {
                        this.$message.info(this.$t('tips_cancel_operation'))
                    })
                }else
                if(arr.length==0){
                    this.$message.warning('请选择删除数据');

                }
            },

            async getList(){
                let param={
                    i_mobile_uid:this.data.val.i_userid,
                };
                let res=await API.getList(param);
                if ( res.code == 1 ){
                    this.tableData=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
</style>